import { ObservableMap } from 'owa-mobx4-adapter';
import { createStore } from 'satcheljs';
var mailStoreData = {
    clientOptedIn: true,
    conversationNodes: new ObservableMap({}),
    conversations: new ObservableMap({}),
    items: new ObservableMap({}),
    mailModule: {
        showReadingPane: false,
        showListPane: true,
        showFolderPane: true,
        isInNonDynamicFolderExpansionMode: false,
    },
    searchFolderDisplayName: null,
    todayDate: null,
    typeOfItemBeingDragged: null,
};
export var getStore = createStore('mail', mailStoreData);
var store = getStore();
export default store;
export var getMailModuleStore = function () { return store.mailModule; };
//# sourceMappingURL=Store.js.map